import { camelCase } from 'camel-case';
import { tasksConstants } from './constants';
import { tasksAPI } from '../../common/api/tasks';
import { errorsActions } from '../errors/actions';

let nextTasksRequestId = 0;

const isAbortError = error =>
  error?.name === 'CanceledError' ||
  error?.name === 'AbortError' ||
  error?.code === 'ERR_CANCELED';

function getTasks(options) {
  nextTasksRequestId += 1;
  const requestId = nextTasksRequestId;

  function request() {
    return { type: tasksConstants.GET_TASKS_REQUEST, requestId };
  }
  function success(tasks, meta) {
    return { type: tasksConstants.GET_TASKS_SUCCESS, tasks, meta, requestId };
  }
  function failure(error) {
    return { type: tasksConstants.GET_TASKS_FAILURE, error, requestId };
  }

  return dispatch => {
    dispatch(request());

    return tasksAPI.getTasks(options).then(
      ({ tasks, meta }) => {
        dispatch(
          success(
            tasks.map(task => ({ ...task, targetAttribute: camelCase(task.targetAttribute) })),
            meta,
          ),
        );
      },
      error => {
        if (isAbortError(error)) return;
        return dispatch(errorsActions.handleErrors(failure))(error);
      },
    );
  };
}

export const tasksActions = {
  getTasks,
};
